import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const FileTranslationKeys = {
  drawingClear: translationKey('drawing_clear'),
  drawingDraw: translationKey('drawing_draw'),
  fileDirectoryAttachmentNotSupported: translationKey('file_directory_attachment_not_supported'),
  fileInputDescription: translationKey('file_input_description'),
  fileInputDescriptionEditLabel: translationKey('file_input_description_edit_label'),
  fileRotationLabel: translationKey('file_rotation_label'),
  fileTypeNotSupportedForGraphicOperation: translationKey('file_type_not_supported_for_graphic_operation'),
  fileUploadButtonLabel: translationKey('file_upload_button_label'),
  fileUploadErrorFileTooBig: translationKey('file_upload_error_file_tooBig'),
  fileUploadErrorFileTypeNotSupported: translationKey('file_upload_error_file_type_not_supported'),
  fileUploadErrorGeneral: translationKey('file_upload_error_general'),
  fileUploadErrorTooBigAndUnsupported: translationKey('file_upload_error_tooBig_and_unsupported'),
  galleryShareLinkCopiedSnackbar: translationKey('gallery_share_link_copied_snackbar'),
  galleryShareLinkLabel: translationKey('gallery_share_link_label'),
  imageConvertInfoFailed: translationKey('image_convert_info_failed'),
  imageConvertInfoIncorrectPages: translationKey('image_convert_info_incorrect_pages'),
  imageConvertInfoPending: translationKey('image_convert_info_pending'),
  imageConvertInfoSupportedExtensions: translationKey('image_convert_info_supported_extensions'),
  imageConvertInfoUnconvertable: translationKey('image_convert_info_unconvertable'),
  mainImageDisabledImageNotUploadedYet: translationKey('main_image_disabled_image_not_uploaded_yet'),
  manyFilesError: translationKey('many_files_error'),
  thumbnailBulkDelete: translationKey('thumbnail_bulk_delete'),
  thumbnailBulkUnlink: translationKey('thumbnail_bulk_unlink'),
  tooManyFiles: translationKey('too_many_files'),
  uploadForFileFailed: translationKey('upload_for_file_failed'),
  useAsMainImage: translationKey('use_as_main_image'),
} as const satisfies Record<string, TranslationKey>;
